import { render, staticRenderFns } from "./login-secretaria.vue?vue&type=template&id=54855fbd"
import script from "./login-secretaria.vue?vue&type=script&lang=js"
export * from "./login-secretaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports